import { jsxs as l, jsx as C } from "react/jsx-runtime";
import { getIconStyles as d } from "../styles.js";
const r = (e) => /* @__PURE__ */ l(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: d(e),
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_818_20640)", children: [
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.24091 0.399632C3.87787 0.135795 4.56056 0 5.25 0C5.93944 0 6.62213 0.135795 7.25909 0.399632C7.89605 0.66347 8.4748 1.05018 8.96231 1.53769C9.44982 2.0252 9.83653 2.60395 10.1004 3.24091C10.3642 3.87787 10.5 4.56056 10.5 5.25C10.5 5.93944 10.3642 6.62213 10.1004 7.25909C9.83653 7.89605 9.44982 8.4748 8.96231 8.96231C8.4748 9.44982 7.89605 9.83653 7.25909 10.1004C6.62213 10.3642 5.93944 10.5 5.25 10.5C4.56056 10.5 3.87787 10.3642 3.24091 10.1004C2.60395 9.83653 2.0252 9.44982 1.53769 8.96231C1.05018 8.4748 0.66347 7.89605 0.399632 7.25909C0.135795 6.62213 0 5.93944 0 5.25C0 4.56056 0.135795 3.87787 0.399632 3.24091C0.66347 2.60395 1.05018 2.0252 1.53769 1.53769C2.0252 1.05018 2.60395 0.66347 3.24091 0.399632ZM5.25 1.5C4.75754 1.5 4.26991 1.597 3.81494 1.78545C3.35997 1.97391 2.94657 2.25013 2.59835 2.59835C2.25013 2.94657 1.97391 3.35997 1.78545 3.81494C1.597 4.26991 1.5 4.75754 1.5 5.25C1.5 5.74246 1.597 6.23009 1.78545 6.68506C1.97391 7.14003 2.25013 7.55343 2.59835 7.90165C2.94657 8.24987 3.35997 8.52609 3.81494 8.71455C4.26991 8.903 4.75754 9 5.25 9C5.74246 9 6.23009 8.903 6.68506 8.71455C7.14003 8.52609 7.55343 8.24987 7.90165 7.90165C8.24987 7.55343 8.52609 7.14003 8.71455 6.68506C8.903 6.23009 9 5.74246 9 5.25C9 4.75754 8.903 4.26991 8.71455 3.81494C8.52609 3.35997 8.24987 2.94657 7.90165 2.59835C7.55343 2.25013 7.14003 1.97391 6.68506 1.78545C6.23009 1.597 5.74246 1.5 5.25 1.5Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.25 2.25C5.66421 2.25 6 2.58579 6 3V4.5H6.75C7.16421 4.5 7.5 4.83579 7.5 5.25C7.5 5.66421 7.16421 6 6.75 6H5.25C4.83579 6 4.5 5.66421 4.5 5.25V3C4.5 2.58579 4.83579 2.25 5.25 2.25Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21 20.25C21 19.8358 21.3358 19.5 21.75 19.5H23.25C23.6642 19.5 24 19.8358 24 20.25V23.25C24 23.6642 23.6642 24 23.25 24C22.8358 24 22.5 23.6642 22.5 23.25V21H21.75C21.3358 21 21 20.6642 21 20.25Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 20.25C0 19.8358 0.335786 19.5 0.75 19.5H6.75C7.16421 19.5 7.5 19.8358 7.5 20.25C7.5 20.6642 7.16421 21 6.75 21H1.5V23.25C1.5 23.6642 1.16421 24 0.75 24C0.335786 24 0 23.6642 0 23.25V20.25Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.327 12.7883C2.13266 12.7766 1.94139 12.8409 1.79361 12.9677C1.64582 13.0944 1.55312 13.2737 1.53509 13.4675C1.51737 13.6581 1.57314 13.848 1.69077 13.9986L6.18155 19.2379C6.2519 19.32 6.33925 19.386 6.43746 19.4312C6.53568 19.4764 6.64188 19.4999 6.75 19.5L11.2501 19.5C11.6643 19.5 12.0001 19.8357 12.0001 20.25C12.0001 20.6642 11.6643 21 11.2501 21L6.75 21C6.42563 20.9998 6.10473 20.9294 5.81009 20.7937C5.51546 20.658 5.25364 20.4603 5.04258 20.214L0.542662 14.9641C0.537417 14.9579 0.53227 14.9517 0.527225 14.9454C0.161612 14.49 -0.0125583 13.9102 0.0415346 13.3286C0.0956274 12.7471 0.373743 12.2093 0.817089 11.8291C1.26044 11.4489 1.83426 11.2559 2.41727 11.2911C3.00028 11.3262 3.54677 11.5867 3.94122 12.0174C3.94674 12.0235 3.95216 12.0296 3.95748 12.0358L7.78499 16.5H11.2501C11.6643 16.5 12.0001 16.8357 12.0001 17.25C12.0001 17.6642 11.6643 18 11.2501 18H7.4401C7.2212 18 7.01322 17.9043 6.87073 17.7381L2.82808 13.023C2.69716 12.8839 2.51795 12.7999 2.327 12.7883Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21 17.25C21 16.8358 21.3358 16.5 21.75 16.5C22.3467 16.5 22.919 16.7371 23.341 17.159C23.7629 17.581 24 18.1533 24 18.75C24 19.3467 23.7629 19.919 23.341 20.341C22.919 20.7629 22.3467 21 21.75 21C21.3358 21 21 20.6642 21 20.25C21 19.8358 21.3358 19.5 21.75 19.5C21.9489 19.5 22.1397 19.421 22.2803 19.2803C22.421 19.1397 22.5 18.9489 22.5 18.75C22.5 18.5511 22.421 18.3603 22.2803 18.2197C22.1397 18.079 21.9489 18 21.75 18C21.3358 18 21 17.6642 21 17.25Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.1135 2.48851C14.7465 1.85558 15.6049 1.5 16.5 1.5C17.3951 1.5 18.2536 1.85558 18.8865 2.48851C19.5194 3.12145 19.875 3.97989 19.875 4.875C19.875 5.77011 19.5194 6.62855 18.8865 7.26149C18.2536 7.89442 17.3951 8.25 16.5 8.25C15.6049 8.25 14.7465 7.89442 14.1135 7.26149C13.4806 6.62855 13.125 5.77011 13.125 4.875C13.125 3.97989 13.4806 3.12145 14.1135 2.48851ZM16.5 3C16.0027 3 15.5258 3.19754 15.1742 3.54917C14.8225 3.90081 14.625 4.37772 14.625 4.875C14.625 5.37228 14.8225 5.84919 15.1742 6.20083C15.5258 6.55246 16.0027 6.75 16.5 6.75C16.9973 6.75 17.4742 6.55246 17.8258 6.20083C18.1775 5.84919 18.375 5.37228 18.375 4.875C18.375 4.37772 18.1775 3.90081 17.8258 3.54917C17.4742 3.19754 16.9973 3 16.5 3Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.0983 9.34835C13.8016 8.64509 14.7554 8.25 15.75 8.25H17.25C18.2446 8.25 19.1984 8.64509 19.9017 9.34835C20.6049 10.0516 21 11.0054 21 12V14.25C21 14.8467 20.7629 15.419 20.341 15.841C20.1014 16.0805 19.8134 16.2605 19.5 16.3713V21.75C19.5 22.3467 19.2629 22.919 18.841 23.341C18.419 23.7629 17.8467 24 17.25 24H15.75C15.1533 24 14.581 23.7629 14.159 23.341C13.7371 22.919 13.5 22.3467 13.5 21.75V16.3713C13.1866 16.2605 12.8986 16.0805 12.659 15.841C12.2371 15.419 12 14.8467 12 14.25V12C12 11.0054 12.3951 10.0516 13.0983 9.34835ZM15.75 9.75C15.1533 9.75 14.581 9.98705 14.159 10.409C13.7371 10.831 13.5 11.4033 13.5 12V14.25C13.5 14.4489 13.579 14.6397 13.7197 14.7803C13.8603 14.921 14.0511 15 14.25 15C14.6642 15 15 15.3358 15 15.75V21.75C15 21.9489 15.079 22.1397 15.2197 22.2803C15.3603 22.421 15.5511 22.5 15.75 22.5H17.25C17.4489 22.5 17.6397 22.421 17.7803 22.2803C17.921 22.1397 18 21.9489 18 21.75V15.75C18 15.3358 18.3358 15 18.75 15C18.9489 15 19.1397 14.921 19.2803 14.7803C19.421 14.6397 19.5 14.4489 19.5 14.25V12C19.5 11.4033 19.2629 10.831 18.841 10.409C18.419 9.98705 17.8467 9.75 17.25 9.75H15.75Z",
            fill: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "clip0_818_20640", children: /* @__PURE__ */ C("rect", { width: "24", height: "24", fill: "white" }) }) })
    ]
  }
);
export {
  r as VisitIcon
};
//# sourceMappingURL=VisitIcon.js.map
